import React from 'react';
import { FaAward, FaShieldAlt, FaClock, FaCheckCircle } from 'react-icons/fa';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './About.css';

const About = () => {
  const titleRef = useScrollAnimation();
  const featuresRef = useScrollAnimation();
  const statsRef = useScrollAnimation();
  const stats = [
    { number: '400+', label: 'Projects Completed' },
    { number: '12+', label: 'Years Experience' },
    { number: '100%', label: 'Customer Satisfaction' },
    { number: '100%', label: 'Financing Available' }
  ];

  return (
    <section id="about" className="section about" aria-labelledby="about-title">
      <div className="container">
        <div className="about-content pad-h-sm-5">
          <div className="about-text">
            <h2 id="about-title" ref={titleRef} className="section-title">About <span className="txtYellow2">RC Remodel</span></h2>
            <p className="about-intro">
              With over 12 years of experience in home remodeling, RC Remodel has built a 
              reputation for excellence, reliability, and exceptional craftsmanship. We understand 
              that your home is your most valuable investment, and we treat every project with 
              the care and attention it deserves.
            </p>
            <p>
              Our team of licensed professionals combines traditional craftsmanship with modern 
              techniques to deliver results that exceed expectations. From concept to completion, 
              we ensure every detail is handled with precision and professionalism.
            </p>
            <div ref={featuresRef} className="about-features">
              <div className="feature">
                <FaShieldAlt className="feature-icon" />
                <div>
                  <h3>Licensed & Insured</h3>
                  <p>Fully licensed contractors with comprehensive insurance coverage</p>
                </div>
              </div>
              <div className="feature">
                <FaAward className="feature-icon" />
                <div>
                  <h3>Quality Materials</h3>
                  <p>We use only the finest materials from trusted suppliers</p>
                </div>
              </div>
              <div className="feature">
                <FaClock className="feature-icon" />
                <div>
                  <h3>Timely Completion</h3>
                  <p>Projects completed on time and within budget</p>
                </div>
              </div>
            </div>
          </div>
          
          <div ref={statsRef} className="about-stats-wrapper">
            <div className="about-stats">
              <div className="stats-grid">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-item">
                    <h3>{stat.number}</h3>
                    <p>{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
